const firebaseConfig = {
  apiKey: "AIzaSyB2qPlwjk6Qfg6XtOHOP2yXWfdl7qoWBkw",
  authDomain: "uems-4856a.firebaseapp.com",
  projectId: "uems-4856a",
  storageBucket: "uems-4856a.firebasestorage.app",
  messagingSenderId: "419400510562",
  appId: "1:419400510562:web:017686f6af9da032f5353b",
  measurementId: "G-J2WNX5QV8H"
};


export default firebaseConfig;
